import { isBox } from './item-is-box.util';
export const isInBox = function isInBox(item) {
  if (!item) {
    return false;
  }
  const {
    boxItemsId
  } = item;
  return Boolean(boxItemsId && !isBox(item));
};